import { gatewayUrl } from "@Constants/gatewayUrl";
import { useUserContext } from "@Hooks/contexts/useUserContext";
import { getCurrentDocumentAsBlob } from "@Hooks/office/useWordSelection";
import { createConfig } from "@Utils/createConfig";
import axios from "axios";
export const useTempDocumentPath = ()=>{
    const token = useUserContext((s)=>s?.user?.meta?.access_token.token);
    const url = `${gatewayUrl}/timelinedocuments/getSignedUploadUrlForTempDocument`;
    const header = createConfig(token);
    const getTempDocumentPath = async ()=>{
        const { blob } = await getCurrentDocumentAsBlob();
        const presignedBody = {
            mimeType: blob.type
        };
        const { data: { presignedUrl, path } } = await axios.post(url, presignedBody, header);
        await axios.put(presignedUrl, blob, {
            headers: {
                "Content-Type": blob.type,
                "x-amz-acl": "public-read"
            }
        });
        return path;
    };
    return getTempDocumentPath;
};
